import { useEffect, useState } from 'react';
import client from '../sanityClient'; // Make sure this path is correct!

export default function useFashionItems() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const query = `*[_type == "item" && enabled == true] {
      ...,
      "videos": videos[].asset->url
    } | order(order asc)`;
    client.fetch(query)
      .then((data) => {
        setItems(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Sanity fetch error:', err);
        setLoading(false);
      });
  }, []);

  return { items, loading };
}